
export default function Testimonials() {
  const testimonials = [
    {
      quote: '考虑到软件的独特功能和操作PDF的能力，在上市时间方面非常有用。',
      product: 'Adobe PDF Library',
      source: 'CAPTERRA',
      rating: 4.8,
      icon: 'https://www.datalogics.com/icons/capterra-1.svg',
    },
    {
      quote: 'Adobe PDF Library是一个非常高质量的SDK，适用于所有PDF相关操作。',
      product: 'Adobe PDF Library',
      source: 'SOURCEFORGE',
      rating: 4.5,
      color: '#F68A1F',
    },
    {
      quote: 'Adobe PDF Library拥有非常全面的文档、一流的支持、涵盖整个PDF规范，并且与Acrobat具有相同的代码库。',
      product: 'Adobe PDF Library',
      source: 'SOURCEFORGE',
      rating: 4.5,
      color: '#F68A1F',
    },
  ];

  const renderStars = (rating: number) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <i key={`full-${i}`} className="ri-star-fill text-yellow-400"></i>
      );
    }
    if (hasHalfStar) {
      stars.push(
        <i key="half" className="ri-star-half-fill text-yellow-400"></i>
      );
    }
    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <i key={`empty-${i}`} className="ri-star-line text-yellow-400"></i>
      );
    }
    return stars;
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            客户评价
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            听听我们客户的真实反馈
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gray-50 p-8 rounded-xl border border-gray-200 hover:shadow-lg transition-all duration-300 hover:scale-105"
            >
              <div className="mb-6">
                <i className="ri-double-quotes-l text-3xl text-teal-600 mb-4 block"></i>
                <blockquote>
                  <p className="text-lg text-gray-900 leading-relaxed italic">
                    "{testimonial.quote}"
                  </p>
                </blockquote>
              </div>
              <div className="text-sm text-gray-500 mb-6 pb-6 border-b border-gray-200">
                {testimonial.product}
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  {testimonial.icon ? (
                    <div className="flex items-center gap-2">
                      <img
                        src={testimonial.icon}
                        alt={testimonial.source}
                        className="h-6 w-6"
                      />
                      <span className="font-bold text-gray-900 tracking-tight">
                        {testimonial.source}
                      </span>
                    </div>
                  ) : (
                    <div className="flex items-center gap-2">
                      <i className="ri-sourceforge text-2xl" style={{ color: testimonial.color }}></i>
                      <span className="font-bold tracking-tight" style={{ color: testimonial.color }}>
                        {testimonial.source}
                      </span>
                    </div>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex text-yellow-400">
                    {renderStars(testimonial.rating)}
                  </div>
                  <span className="text-sm text-gray-500">{testimonial.rating}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
